import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getBundles = async (salonId: string | undefined) => {
  const { data: bundles, error: bundlesError } = await supabase
    .from('service_bundles')
    .select(`
      *,
      service_bundle_items (
        service_id,
        services:service_id (
          *,
          service_pricing_duration (*)
        )
      )
    `)
    .eq('salon_id', salonId)
    .eq('is_active', true)

  if (bundlesError) {
    throw new Error(bundlesError.message)
  }

  return bundles
}

export default function useGetBundlesBySalonId(salonId: string | undefined) {
  return useQuery({
    queryKey: ['bundlesBySalon', salonId],
    queryFn: () => getBundles(salonId),
    enabled: !!salonId
  })
} 